import { Area } from '@/models/WeatherWarning'
import { AlertKind2, AlertKind2Attrs, River, RiverAttrs } from '@/models/WeatherWarning2'

// R08気象警報注意報履歴API（app2 / weather-warning-history2）
// 単体取得API（WeatherWarning2）の出力に targetTime を加えた配列
export type WeatherWarningHistory2ItemAttrs = {
  areaCode: string
  area: Area
  publishingOffice: string
  headline: string
  updatedAt: string
  targetTime: string
  kinds: AlertKind2Attrs[]
  rivers?: RiverAttrs[]
}

export type WeatherWarningHistory2Attrs = WeatherWarningHistory2ItemAttrs[]

export class WeatherWarningHistory2Item {
  public areaCode: string
  public area: Area
  public publishingOffice: string
  public headline: string
  public updatedAt: string
  public targetTime: string
  public kinds: AlertKind2[]
  public rivers: River[]

  constructor(attrs: WeatherWarningHistory2ItemAttrs) {
    this.areaCode = attrs.areaCode
    this.area = attrs.area
    this.publishingOffice = attrs.publishingOffice
    this.headline = attrs.headline
    this.updatedAt = attrs.updatedAt
    this.targetTime = attrs.targetTime
    this.kinds = (attrs.kinds ?? []).map(kind => new AlertKind2(kind))
    this.rivers = (attrs.rivers ?? []).map(river => new River(river))
  }

  public findKind(code: string) {
    return this.kinds.find(kind => kind.code === code)
  }

  // 種別は注意報/警報/危険警報/特別警報など複数コードを束ねるため、いずれかに合致する kind を返す
  public findKindByCodes(codes: string[]) {
    return this.kinds.find(kind => codes.includes(kind.code))
  }
}

export default class WeatherWarningHistory2 {
  public weatherWarningData: WeatherWarningHistory2Item[]

  constructor(attrs: WeatherWarningHistory2Attrs) {
    this.weatherWarningData = attrs.map(itemAttrs => new WeatherWarningHistory2Item(itemAttrs))
  }
}
